import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "square",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M8.5 5.5 12 2l3.5 3.5L12 9zM15 12.5 18.5 9l3.5 3.5-3.5 3.5zM8.5 18.5 12 15l3.5 3.5L12 22zM2 12l3.5-3.5L9 12l-3.5 3.5z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }